import {
  AddCertificationInput,
  AddCertificationOutput,
  CertificationBuilder,
} from '../certifications.types';

export const addCertification = (builder: CertificationBuilder) =>
  builder.mutation<AddCertificationOutput, AddCertificationInput>({
    query: (args) => ({
      url: 'candidate-certifications',
      method: 'POST',
      body: args,
    }),
    invalidatesTags: () => [{ type: 'Certification' }],
  });
